var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinProfilesScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".white{fill:#fff;}.linkedin{fill:url(#linkedin-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linkedin-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#95d7e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28434,
    stopColor: "#4495cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48367,
    stopColor: "#0a66c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b3990"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "linkedin",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M73.86951,32.58051c-.38361-3.39447-3.05554-6.06641-6.45001-6.45001-11.61298-1.3125-23.22595-1.3125-34.83899,0-3.39441.38361-6.06635,3.05554-6.45001,6.45001-1.31244,11.61298-1.31244,23.22595,0,34.83899.38367,3.39441,3.0556,6.06635,6.45001,6.45001.00592.00067.0119.0011.01782.00177-.40674-.62451-.64807-1.36688-.64807-2.16772v-3.57306c2.4436-7.62213,9.55585-13.15668,17.97894-13.18793-6.43829-.04126-11.56079-5.62738-10.8233-12.22485.55988-5.0083,4.633-9.0769,9.64185-9.63177,6.61652-.73303,12.21722,4.42706,12.21722,10.89532,0,6.03186-4.87134,10.92273-10.8941,10.9613,8.42291.03125,15.5351,5.56567,17.97888,13.18762v3.57336c0,.80084-.24133,1.54321-.64807,2.16772.00592-.00067.0119-.0011.01782-.00177,3.39447-.38367,6.06641-3.0556,6.45001-6.45001,1.3125-11.61304,1.3125-23.22601,0-34.83899Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinProfilesScraper);
export default __webpack_public_path__ + "static/media/linkedin-profiles-scraper.1f845944942a332315cfafa3a74fcb43.svg";
export { ForwardRef as ReactComponent };